import { createAction } from '@reduxjs/toolkit'

import { RpiRoutes, RpiDevice, RpiHealthcheck, RpiStreamInfo, RpiCurrentStream } from './types'

export const devicesList = createAction<RpiDevice[]>(RpiRoutes.DEVICES)

export const devicesUpdate = createAction<RpiDevice[]>(RpiRoutes.DEVICES_UPDATE)

export const devicesSave = createAction<RpiDevice[]>(RpiRoutes.DEVICES_SAVE)

export const msvStart = createAction<any>(RpiRoutes.MSV)

export const streamsList = createAction<RpiStreamInfo[]>(RpiRoutes.STREAMS)

export const streamStart = createAction<RpiCurrentStream>(RpiRoutes.STREAM_START)

export const streamStop = createAction<{ stream: RpiStreamInfo, device: RpiDevice }>(RpiRoutes.STREAM_STOP)

export const test = createAction<RpiHealthcheck>(RpiRoutes.TEST)
